<template>
  <div class="member-discounts bg-background-light px-6 py-10 md:py-16 text-left tracking-0.15px">
    <div class="mx-auto w-full max-w-screen-sm">
      <h6 class="text-lg md:text-2xl text-black-high-emphasis mb-6 md:mb-8">
        {{ content.title }}
      </h6>
      <div v-dompurify-html="content.discounts" class="richtext"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { MemberDiscounts } from '@/model'

export default defineComponent({
  props: {
    content: {
      type: MemberDiscounts,
      required: true,
      validator: (value: MemberDiscounts) => value instanceof MemberDiscounts
    }
  }
})
</script>
